import produce from 'immer'
import { assign } from 'lodash'

import {
  FETCH_COURSE_TYPE,
  UPDATE_COURSE_TYPE_DETAILS,
  UPDATE_COURSE_TYPE_IMAGE_DETAILS,
} from '../action-types'
import { COURSE_TYPE_INITIAL_STATE } from '../initial-states'

const courseTypeReducer = (state = COURSE_TYPE_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COURSE_TYPE.START:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: true,
          fetchError: undefined,
          data: [],
        }),
      )

    case FETCH_COURSE_TYPE.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: undefined,
          data: action.payload.data.courseType,
        }),
      )

    case FETCH_COURSE_TYPE.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: action.error.message,
          data: [],
        }),
      )

    case FETCH_COURSE_TYPE.CLEANUP:
      return { ...COURSE_TYPE_INITIAL_STATE }

    case UPDATE_COURSE_TYPE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateDetailsLoading: true,
          updateDetailsError: undefined,
        }),
      )

    case UPDATE_COURSE_TYPE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateDetailsLoading: false,
          updateDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateCourseTypeDetails,
          ),
        }),
      )

    case UPDATE_COURSE_TYPE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateDetailsLoading: false,
          updateDetailsError: action.error.message,
        }),
      )

    case UPDATE_COURSE_TYPE_IMAGE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: true,
          imageDetailsError: undefined,
        }),
      )

    case UPDATE_COURSE_TYPE_IMAGE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateCourseTypeImageDetails,
          ),
        }),
      )

    case UPDATE_COURSE_TYPE_IMAGE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: action.error.message,
        }),
      )
    default:
      return state
  }
}

export default courseTypeReducer
